<template>
    <v-app>
        <v-card width="500px" class="mx-auto mt-5">
            <v-card-title>ログイン</v-card-title>

            <v-card-text>
                <v-form @submit="post" @submit.prevent>
                    <v-text-field prepend-icon="mdi-account-circle" label="ID" v-model="authId" />
                    <v-text-field v-bind:type="showPassword ? 'text' : 'password'" prepend-icon="mdi-lock"
                        v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'
                            " label="パスワード" @click:append="showPassword = !showPassword" v-model="authPass" />
                    <v-card-actions>
                        <v-btn block class="info" type="submit">ログイン</v-btn>
                    </v-card-actions>

                    <v-alert text v-bind:type="alert ? 'error' : 'info'">
                        {{ msg }}
                    </v-alert>
                </v-form>
            </v-card-text>
        </v-card>
    </v-app>
</template>

<script>
export default {
    title: "ログイン",
    name: "login",
    data() {
        return {
            showPassword: false,
            msg: "IDとパスワードを入力して下さい",
            authId: "",
            authPass: "",
            alert: false,
        };
    },
    methods: {
        async post() {
            const data = { id: this.authId, pass: this.authPass };
            const { user, token } = await this.$axios
                .post("/api/v1/auth", data)
                .then(response => {
                    this.msg = response.data.message;
                    return { user: response.data.user, token: response.data.token };
                })
                .catch(error => {
                    this.msg = error.message;
                    return [{}, ''];
                });

            if (this.msg == "OK") {
                this.$store.dispatch("fetch", { user, token });
                location.href = "/";
            } else {
                this.alert = true;
            }
        },
    },
};
</script>
